import { render, staticRenderFns } from "./searchRes.vue?vue&type=template&id=57dd2dd6&scoped=true&"
import script from "./searchRes.vue?vue&type=script&lang=js&"
export * from "./searchRes.vue?vue&type=script&lang=js&"
import style0 from "./searchRes.vue?vue&type=style&index=0&id=57dd2dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dd2dd6",
  null
  
)

export default component.exports